import { MetaReducer, Action, provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { createLocalStorageSyncReducer } from '../../shared/utils/local-storage-sync';
import { MetadataTagsReducer, MetadataTagsState } from './state/reducers/metadata-tags.reducer';
import { metaDataTagsStateKey } from './state';
import { MetadataTagsEffects } from './state/effects/metadata-tags.effects';
import { MetadataTagsFacade } from './facade/metadata-tags.facade';
import { MetadataTagsService } from './service/metadata-tags.service';
import { MetadataTagsRoutes } from './metadata-tags.routing';
import { provideRouter } from '@angular/router';

const localStorageSyncReducer = createLocalStorageSyncReducer<MetadataTagsState>(['metadataTags']);

const metaReducers: Array<MetaReducer<MetadataTagsState, Action>> = [localStorageSyncReducer];

export const metadataTagsConfig = [
  provideState(metaDataTagsStateKey, MetadataTagsReducer, { metaReducers }),
  provideEffects([MetadataTagsEffects]),
  provideRouter(MetadataTagsRoutes),
  MetadataTagsFacade,
  MetadataTagsService,
];
